import Vue from 'vue'
import {Menu} from 'ant-design-vue'
import {Button} from 'ant-design-vue';
import {Breadcrumb} from 'ant-design-vue';
import {Icon} from 'ant-design-vue';
import {DatePicker} from 'ant-design-vue';
import { Checkbox } from 'ant-design-vue';
import { Input } from 'ant-design-vue';
import { ConfigProvider } from 'ant-design-vue';
import { Form } from 'ant-design-vue';
import {Table} from 'ant-design-vue'
import {Col} from 'ant-design-vue'
import {Card} from 'ant-design-vue'
import {Row} from 'ant-design-vue'
import {List} from 'ant-design-vue'
import {Tabs} from 'ant-design-vue'
import {Tag} from 'ant-design-vue'
import {Popover} from 'ant-design-vue'
import {Select} from 'ant-design-vue'
import {Cascader} from 'ant-design-vue'
import {Pagination} from 'ant-design-vue'
import {Upload} from 'ant-design-vue'
import {message} from 'ant-design-vue'
import {Tooltip} from 'ant-design-vue'
import {Modal} from 'ant-design-vue'
import {Steps} from 'ant-design-vue'
import {Divider} from 'ant-design-vue'
import {Radio} from 'ant-design-vue'
import { Switch } from 'ant-design-vue'
import { Spin } from 'ant-design-vue'
import { Space } from 'ant-design-vue'
import { Descriptions } from 'ant-design-vue'
message.config({
    maxCount: 1,
});
Vue.prototype.$Message = message;
Vue.prototype.$Modal = Modal;
Vue.prototype.$Confirm = Modal.confirm;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.use(Spin);
Vue.use(Tag);
Vue.use(Radio)
Vue.use(Space)
Vue.use(message)
Vue.use(Upload)
Vue.use(Icon)
Vue.use(Form)
Vue.use(Breadcrumb)
Vue.use(Button)
Vue.use(Descriptions)
Vue.use(Menu)
Vue.use(Input)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(Checkbox)
Vue.use(ConfigProvider)
Vue.use(Table)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(List)
Vue.use(Tabs)
Vue.use(Popover)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Tooltip)
Vue.use(Modal)
Vue.use(Steps)
Vue.use(Divider)
Vue.use(Switch)
